import styled from "styled-components";

export const StyledVariantsToggleWrapper = styled.div`
  display: flex;
  gap: 2.4rem;
`;
